import React from 'react';
import people from '../../assets/people.png';
import home from '../../assets/main.jpg';
import './header.css';
import { Link } from 'react-router-dom';

const Header = () => (
  <div className="gpt3__header" id="home">
    <div className="gpt3__header-content">
      <div className="gpt3__header-badge">
        <span>🏆 Trusted by 1,600+ Families</span>
      </div>
      <h1 className="gradient__text">Find the Best Educator at Your Doorstep</h1>
      <p>
        We provide top-rated home tutors in <strong>Noida and Ghaziabad</strong> at affordable prices. From academics (<strong>Nursery to Intermediate</strong>) to extracurriculars like <strong>Music, Dance, and Martial Arts</strong> — expert teachers delivered to your home.
      </p>

      <div className="gpt3__header-content__input">
        <input type="email" placeholder="Enter your email address" />
        <Link to="/contact">
          <button type="button">Get Started</button>
        </Link>
      </div>

      <div className="gpt3__header-content__people">
        <img src={people} alt='people' />
        <p>1,600+ families requested a visit in the last 24 hours</p>
      </div>
    </div>

    <div className="gpt3__header-image">
      <img src={home} alt='home tutor' />
    </div>
  </div>
);

export default Header;